import { role as roleService } from '../../services';

export const ActionTypes = {
  SET_ALL_ROLES: 'SET_ALL_ROLES',
  SET_SELECTED_ROLE: 'SET_SELECTED_ROLE',
  CLEAR_SELECTED_ROLE: 'CLEAR_SELECTED_ROLE',
  API_ERROR: 'API_ERROR',
};

/**
 * @description action creator for selecting a role by title
 */
export const fetchAllRoles = () => {
  return async (dispatch) => {
    try {
      const roles = await roleService.fetchAllRoles();
      dispatch({ type: ActionTypes.SET_ALL_ROLES, payload: roles });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_ALL_ROLES,
          error,
        },
      });
    }
  };
};

/**
 * @description action creator for setting selected role
 */
export const setSelectedRole = (roleId) => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.SET_SELECTED_ROLE, payload: roleId });
  };
};

/**
 * @description action creator for clearing selected role
 */
export const clearSelectedRole = () => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.CLEAR_SELECTED_ROLE });
  };
};
